import axios from 'axios'

export default class Colaboradores {
  constructor (tokenBearer, url, id, areaId) {
    this.url = `${url}/api/unimed/areas/colaborador/${id}?areaId=${areaId}`
    this.urlCola = `${url}/api/unimed/areas/colaboradores/${id}`
    this.urlEdicao = `${url}/api/unimed/areas/colaboradoresEdicao/${id}`
    this.tokenBearer = tokenBearer
  }

  getColaboradoresEdicao (args = '') {
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'get',
        url: `${this.urlEdicao}/${args}`,
        headers: {
          'Authorization': this.tokenBearer
        }
      }

      try {
        let response = await axios(options)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }

  getColaboradores (args = '') {
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'get',
        url: `${this.urlCola}/${args}`,
        headers: {
          'Authorization': this.tokenBearer
        }
      }

      try {
        let response = await axios(options)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }

  deleteColaboradores (data, idArea) {
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'delete',
        url: `${this.url}&areaId=${idArea}`,
        headers: {
          'Authorization': this.tokenBearer
        },
        data
      }

      try {
        let response = await axios(options)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }

  putColaboradores (data, idAreaDestino) {
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'put',
        url: `${this.url}&areaDestinoId=${idAreaDestino}`,
        headers: {
          'Authorization': this.tokenBearer
        },
        data
      }

      try {
        let response = await axios(options)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }
}
